var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrbVpnLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 192 169.9",
    style: {
      enableBackground: "new 0 0 192 169.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#17A090;}\n\t.st1{enable-background:new    ;}\n\t.st2{fill:#208DD4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1_xA0_Image_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.1,120.7h-5c-1.7,0-3,1.3-3,3v42c0,1.7,1.3,3,3,3h5c1.7,0,3-1.3,3-3v-42C15.1,122,13.8,120.7,12.1,120.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37,120.7h-5c-1.7,0-3,1.3-3,3v26c0,1.7,1.3,3,3,3h5c1.7,0,3-1.3,3-3v-26C40,122,38.7,120.7,37,120.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.8,120.7h-5c-1.7,0-3,1.3-3,3v42c0,1.7,1.3,3,3,3h5c1.7,0,3-1.3,3-3v-42C64.8,122,63.4,120.7,61.8,120.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.4,120.7h-5c-1.7,0-3,1.3-3,3v42c0,1.7,1.3,3,3,3h5c1.7,0,3-1.3,3-3v-42C138.4,122,137,120.7,135.4,120.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160,136.7h-5c-1.7,0-3,1.3-3,3v26c0,1.7,1.3,3,3,3h5c1.7,0,3-1.3,3-3v-26C163,138,161.6,136.7,160,136.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.7,120.7h-5c-1.7,0-3,1.3-3,3v42c0,1.7,1.3,3,3,3h5c1.7,0,3-1.3,3-3v-42 C187.7,122,186.4,120.7,184.7,120.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 96,
    cy: 140.7,
    r: 20
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.9,78.2c0,10.6-3.7,19.6-11,27c-7.3,7.4-16.3,11.1-26.9,11.1c-10.7,0-19.7-3.7-27.1-11 c-7.3-7.3-11-16.3-11-27c0-10.6,3.7-19.6,11.1-26.9s16.4-11,27-11c10.6,0,19.6,3.7,26.9,11C74.2,58.6,77.9,67.6,77.9,78.2z  M58.7,78.2c0-5.1-1.8-9.5-5.5-13.2s-8.1-5.5-13.2-5.5c-5.2,0-9.7,1.8-13.4,5.5c-3.7,3.6-5.5,8-5.5,13.2c0,5.2,1.8,9.6,5.5,13.3 S34.7,97,39.9,97c5.2,0,9.6-1.8,13.3-5.5C56.9,87.8,58.7,83.4,58.7,78.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M116,59.5c-5.2,0-9.7,1.8-13.4,5.5c-3.7,3.6-5.5,8.1-5.5,13.3v35.9H77.9V78.2c0-10.6,3.7-19.6,11.1-26.9 s16.4-11,27-11V59.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M191.6,78.2c0,10.6-3.7,19.6-11,27c-7.3,7.4-16.3,11.1-26.9,11.1c-10.7,0-19.7-3.7-27.1-11 c-7.3-7.3-11-16.4-11-27.1V1.6h19.2v43.5c5.8-3.2,12.1-4.8,18.9-4.8c10.6,0,19.6,3.7,26.9,11C188,58.6,191.6,67.6,191.6,78.2z  M172.5,78.2c0-5.1-1.8-9.5-5.5-13.2s-8.1-5.5-13.2-5.5c-5.2,0-9.7,1.8-13.4,5.5c-3.7,3.6-5.5,8-5.5,13.2c0,5.2,1.8,9.6,5.5,13.3 c3.7,3.7,8.2,5.5,13.4,5.5c5.2,0,9.6-1.8,13.3-5.5C170.6,87.8,172.5,83.4,172.5,78.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrbVpnLogo);
export default __webpack_public_path__ + "static/media/ORB-VPN-Logo.85c3a15e0a9d9a7bf6a5f3b086150a4f.svg";
export { ForwardRef as ReactComponent };